import { FirebaseAnalytics, FirebaseInitOptions } from '@capacitor-community/firebase-analytics'

export const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_APIKEY ?? '',
	authDomain: 'vae-app-7de5b.firebaseapp.com',
	projectId: 'vae-app-7de5b',
	storageBucket: 'vae-app-7de5b.appspot.com',
	messagingSenderId: '703670821773',
	appId: '1:703670821773:web:caf6d3da4f4859d35593c4',
	measurementId: 'G-SLFDCT68W6',
} satisfies FirebaseInitOptions

export const logEvent = async (name: string, params: object = {}): Promise<void> => {
	try {
		return await FirebaseAnalytics.logEvent({ name: name.replaceAll('-', '_'), params })
	} catch (reason) {
		console.error('Failed to log analytics event', reason)
		return
	}
}

export const logNavigation = async (screenName: string): Promise<void> => {
	try {
		if (!screenName) return

		await FirebaseAnalytics.setScreenName({ screenName })

		return FirebaseAnalytics.logEvent({
			name: 'screen_view',
			params: {
				screen: screenName,
			},
		})
	} catch (reason) {
		console.error('Failed to log navigation event', reason)
	}
}

export const setUserProperty = async (
	name: string,
	value: string | null | number | boolean | undefined
): Promise<void> => {
	try {
		return await FirebaseAnalytics.setUserProperty({ name, value: `${value ?? ''}` })
	} catch (reason) {
		console.error('Failed to set user property', reason)
	}
}

export const initializeFirebaseWebAnalytics = async (): Promise<void> => {
	try {
		return await FirebaseAnalytics.initializeFirebase(firebaseConfig)
	} catch (reason) {
		return console.error('Failed to initialize Firebase Analytics', reason)
	}
}

export const setUserId = async (userId: number): Promise<void> => {
	try {
		return await FirebaseAnalytics.setUserId({
			userId: `${userId}`,
		})
	} catch (reason) {
		console.error('Failed to set user ID', reason)
	}
}

export const setAnalyticsEnabled = async (enabled: boolean): Promise<void> => {
	try {
		return await FirebaseAnalytics.setCollectionEnabled({
			enabled,
		})
	} catch (reason) {
		console.error('Failed to set analytics collection enabled', reason)
	}
}
